import { render, staticRenderFns } from "./change-pwd.vue?vue&type=template&id=4ecf6ccd&"
import script from "./change-pwd.vue?vue&type=script&lang=js&"
export * from "./change-pwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports